// External data from classicgraphicsphotography.com
export const classicGraphicsData = {
  companyInfo: {
    name: "Classic Graphics Photography",
    website: "https://classicgraphicsphotography.com/",
    phone: "9949111776",
    email: "[email protected]",
    address: "DNo: 23-4-48, 2nd Street, Lecture's Colony, Magunta Lay-out, Nellore, 524003"
  },
  
  services: [
    {
      title: "Wedding Live",
      description: "Broadcast and share your special moment live online with friends and family from anywhere in the world!",
      phone: "9949111776"
    },
    {
      title: "Private Party",
      description: "Live Stream and share your special events live online with friends and family from anywhere in the world.",
      phone: "9949111776"
    },
    {
      title: "Corporate Events",
      description: "Broadcast and share your corporate events live online with staffs and clients from anywhere in the world.",
      phone: "9949111776"
    }
  ],

  liveStreamingServices: [
    "Wedding Live Streaming",
    "Private Party Live Streaming", 
    "Corporate Events Live Streaming",
    "Enterprise Live Streaming",
    "Product Launch Live Streaming",
    "Music Events Live Streaming",
    "Spiritual Meetings Live Streaming",
    "Live Conference",
    "Educational Events Live Streaming",
    "Sports Events Live Streaming",
    "Government Programmes Live Streaming",
    "Hospital Surgery Live Streaming",
    "Birthday Party Live Streaming",
    "Functions Live Streaming"
  ],

  featuredServices: [
    "Wedding Live",
    "Functions Live", 
    "Corporate Live",
    "Events Live",
    "Birthday Live",
    "Music Live"
  ],

  faqs: [
    {
      question: "How do I book an event?",
      answer: "Call us, WhatsApp, SMS or E-Mail us to check availability, someone from our team will respond as soon as possible."
    },
    {
      question: "Can we expect any delay in Live Streaming?",
      answer: "Our Premium Plans comes with Ultra Low Latency Streaming Technology with ~0.5 seconds latency. Our Basic Plans has 8-12 seconds End-to-End Latency. As the live signal travels through internet, a delay of few seconds variation between live and video can be expected."
    },
    {
      question: "How much does it cost for an event?",
      answer: "Our pricing is based on duration and location of the event, please contact us to know more about our pricing structure."
    },
    {
      question: "Can I live stream the event by myself?",
      answer: "Yes, you can live stream the event by yourself if you have a computer or mobile phone (iOS and Android) with camera and internet connection. Call us to know more!"
    },
    {
      question: "Will the Live Stream Video be available online after my event?",
      answer: "Most of our packages include free recorded video hosting up to 30 days and additional days can be purchased."
    },
    {
      question: "Do you charge separately for your various event services?",
      answer: "Some of our services come standard, others are priced separately. In order to get an idea of what your event will cost, contact us to speak with one of our event planner. They can give you a free estimate based on your individual needs."
    },
    {
      question: "Can I resell your services under my brand name?",
      answer: "Yes, you can resell our services under your brand name. We will provide you with Live Streaming Website to manage all your events under your brand name. Contact us for more information."
    }
  ],

  aboutUs: {
    title: "The Best Live Streaming Company",
    description: "We are a leading live streaming company in India with a great degree of expertise in managing online events.",
    tagline: "We'll Make Your Celebration Very Special!",
    subtitle: "Friendly customer service staff for your all questions!"
  }
};

export default classicGraphicsData;
